import * as z from "zod";
import {
  ExtensionArtifactInvocationPayloadStatusSchema,
  ExtensionArtifactInvocationSchema,
} from "./list-extension-artifact-invocations";

export const getExtensionArtifactInvocation = {
  name: "getExtensionArtifactInvocation" as const,
  input: z.object({ artifactId: z.string(), runId: z.string() }),
  output: z.object({
    invocation: ExtensionArtifactInvocationSchema,
    payloadState: ExtensionArtifactInvocationPayloadStatusSchema,
    payload: z.unknown().nullable(),
  }),
};
